<template>
    <div :class="['tipp-title', {'tipp-title__reload-cb': reloadCb}]">
        <span style="flex: none" class="mr-2">{{ title }}</span>
        <Tipp style="flex: none" :position="position" :text="tipp" />
        <span v-if="reloadCb" style="flex: 1"></span>
        <v-btn v-if="reloadCb" icon small outlined @click="reloadCb" :disabled="loading" :loading="loading">
            <v-icon>mdi-cached</v-icon>
        </v-btn>
    </div>
</template>

<script>
import Tipp from '@/components/Tipp.vue';

export default {
    name: 'TippTitle',
    components: {
        Tipp,
    },
    props: ['title', 'position', 'tipp', 'reloadCb', 'loading'],
};
</script>

<style scoped lang="scss">
    .tipp-title {
        flex: none !important;
        display: flex;
        align-items: center;
    }
    .tipp-title__reload-cb {
        width: 100%;
    }
</style>
